import QuickActionEditDialogModule from './QuickActionEditDialog.module';

export * from './QuickActionEditDialogModuleProps';
export default QuickActionEditDialogModule;
